module.exports = __webpack_public_path__ + "media/icons/ubezpieczenia-baner@2x-2370f561.png";